export const publicRoutesDataTranslation = {
    home: {
        path: "/",
        en: "Home",
        he: "ראשי",
        ar: "الرئيسية",
    },
    about: {
        path: "/about",
        en: "About",
        he: "אודות",
        ar: "من أنا",
    },
    services: {
        path: "/services",
        en: "Services",
        he: "שירות",
        ar: "الخدمات",
    },
    contact: {
        path: "/contact",
        en: "Contact",
        he: "צור קשר",
        ar: "للتواصل",
    },
};
